import { Group } from '@mantine/core';
import { IconCalendarEvent, IconFilter, IconMessageCircle } from '@tabler/icons';
import { FC, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { ContactsContext } from '../../../Service/Context/ContactsContext';
import { openCreateContactModal } from '../../../Organismns/Contact/EditContactModal';
import { useConversationsWidget } from '../../../Service/Context/HubspotContext';
import { ProfileContext } from '../../../Service/Context/ProfileContext';
import ActionIconWithText from './ActionIconWithText';
import InboxIconWithIndicator from './InboxIconWithIndicator';
import NavAddIcon from './NavAddIcon';

interface HandlersProps {
  filter: () => void;
}

const ContactsPageFooter: FC<HandlersProps> = ({ filter }) => {
  const { openWidget } = useConversationsWidget();
  const navigate = useNavigate();
  const { reload } = useContext(ContactsContext);
  const { unreadMessagesProps } = useContext(ProfileContext);
  const { unreadCount } = unreadMessagesProps ?? { unreadCount: 0 };

  return (
    <Group px="xl" pt={5} sx={{ justifyContent: 'space-between' }}>
      <ActionIconWithText useDefaultWidth label="Filter" onClick={filter}>
        <IconFilter />
      </ActionIconWithText>
      <ActionIconWithText label="Events" useDefaultWidth onClick={() => navigate('/')}>
        <IconCalendarEvent />
      </ActionIconWithText>
      <NavAddIcon onClick={() => openCreateContactModal(reload)} />
      <ActionIconWithText useDefaultWidth label="Postfach" onClick={() => navigate('/postbox/inbox')}>
        <InboxIconWithIndicator unreadCount={unreadCount} />
      </ActionIconWithText>
      <ActionIconWithText useDefaultWidth label="Support" onClick={openWidget}>
        <IconMessageCircle />
      </ActionIconWithText>
    </Group>
  );
};

export default ContactsPageFooter;
